// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { postWrapper } from 'helpers/api'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { SubmissionError } from 'redux-form'
import { success } from 'react-notification-system-redux'

const updatePricingManagementDefault = formValues => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const price_initial = castToFloat(formValues.initial)
      const price_subsequent = castToFloat(formValues.subsequent)

      const body = {
        price_initial,
        price_subsequent,
        pricing_group_def: 'default',
        pricing_group_type: 'default',
      }

      try {
        await postWrapper('/priceManagement', body)

        dispatch(success({
          message: 'Successfully updated Pricing Default values.',
        }))
      } catch (err) {
        throw new SubmissionError({
          _error: err.message || 'Uncaught Error!',
        })
      }
    })
  )
)

export default updatePricingManagementDefault
